module.exports = __webpack_public_path__ + "static/rooms-85b1a19a05a2f4977f1b733067581d77.jpg";